import ProcessMetrics from "../../ProcessMetrics";
import { BREAKPOINT_MOBILE } from "../../../../constants/constants";
import { ProcessesColumnStyles } from "../../TimelinesStyles";
import ErrorBoundary from "../../../SimpleComponents/Errors/ErrorBoundary";
import { SERVER_NAMES } from "components/Nav/Drawers/RightDrawer/FlightDebugger/SERVER_NAMES";
import { useMediaQuery } from "@mui/material";
import { DataDumpAggregateType, Process } from "types/types";
import { useFlightTranslation } from "utils/customHooks/useFlightTranslation";
import { GroupMetricType } from "components/DataGetter/FlightConfig/FlightConfigTypes/GroupMetricType";
import { useHighlightedTags } from "components/Dashboard/HubletView/SingleTimeline/singleTimelineStore";

export function MetricsColumns({
  metricsColumns,
  processes,
}: {
  metricsColumns: GroupMetricType[];
  processes: Process[];
}) {
  const { translate } = useFlightTranslation();
  return (
    <>
      {metricsColumns
        .filter(d => d.dataDumpKey)
        .map(
          (
            {
              dataDumpKey,
              displayName,
              displayNameShort,
              units,
              decimalPoints,
              formatHoursMinutes,
            },
            i
          ) => (
            <MetricColumn
              key={dataDumpKey + "-" + i}
              metricName={
                (displayNameShort && translate(displayNameShort)) ?? displayName
              }
              dataDumpKey={dataDumpKey as keyof DataDumpAggregateType}
              processes={processes}
              unit={units}
              decimalPoints={decimalPoints}
              shouldFormatHoursMinutes={formatHoursMinutes}
            />
          )
        )}
    </>
  );
}
function MetricColumn({
  metricName,
  dataDumpKey,
  processes,
  unit,
  decimalPoints,
  shouldFormatHoursMinutes,
}: {
  metricName: string;
  dataDumpKey: keyof DataDumpAggregateType;
  processes: Process[];
  unit: string;
  decimalPoints?: number;
  shouldFormatHoursMinutes?: boolean;
}) {
  // customize the metric display name if necessary
  const isAboveMobile = useMediaQuery(`(min-width: ${BREAKPOINT_MOBILE}px)`);
  const [highlightedTags] = useHighlightedTags();

  const showTagHighlight = highlightedTags.length > 0;
  return (
    <ProcessesColumnStyles
      className={`ProcessesColumnStyles metricsColumn ${metricName}`}
      data-server-names={[SERVER_NAMES.askrAggregates]}
      data-component-name={"Processes Column"}
      $showTagHighlight={showTagHighlight}
    >
      {/* shorten "Availability" to "Avail" under breakpoint */}
      <>
        {isAboveMobile && (
          <div className="title metricTitle">
            {/* hide title when collapsed */}
            {metricName}
          </div>
        )}
        {processes.map((p, idx) => (
          <div className="metricContainer" key={`tlrow-${p.id}-metrics-${idx}`}>
            <ErrorBoundary id="MetricColumn">
              <ProcessMetrics
                processId={p.id}
                dataDumpKey={dataDumpKey}
                unit={unit}
                decimalPoints={decimalPoints}
                shouldFormatHoursMinutes={shouldFormatHoursMinutes}
              />
            </ErrorBoundary>
          </div>
        ))}
      </>
    </ProcessesColumnStyles>
  );
}
